"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notifyEmail = exports.NotifyTypes = void 0;
/**
 * notify('email', {
 * })
 */
const assert = require("assert");
const utils_1 = require("./utils");
const isEmail_1 = require("validator/lib/isEmail");
const fetch = require("isomorphic-fetch");
const API_EMAIL = 'http://mbc.oa.com/v1/alarm/sendemail';
const DOWNLOAD_CENTER = 'https://service-bqvg4bkz-1251316161.bj.apigw.tencentcs.com';
function sendEmail(options) {
    utils_1.assertArgument(options, 'Title');
    utils_1.assertArgument(options, 'Content');
    utils_1.assertArgument(options, 'To');
    assert.ok(options.To.every(e => isEmail_1.default(e)), 'arguments error, email validate failed');
    return fetch(API_EMAIL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(Object.assign(Object.assign({}, options), { To: options.To.join(',') }))
    });
}
function sendCaptcha(options) { }
var NotifyTypes;
(function (NotifyTypes) {
    NotifyTypes[NotifyTypes["EMAIL"] = 0] = "EMAIL";
    NotifyTypes[NotifyTypes["CAPTCHA"] = 1] = "CAPTCHA";
})(NotifyTypes = exports.NotifyTypes || (exports.NotifyTypes = {}));
const NotifyHandler = {
    [NotifyTypes.EMAIL]: sendEmail,
    [NotifyTypes.CAPTCHA]: sendCaptcha
};
function notifyEmail(code, options) {
    assert.ok(code, `arguments error, unexpect code: ${code}`);
    assert.ok(Array.isArray(options.To), `unknown options.To type: ${options.To}`);
    return notify(NotifyTypes.EMAIL, Object.assign({ Title: '下载中心 - 邮件通知', Content: `
      您有新的文件待领取：<a href="${DOWNLOAD_CENTER}/${code}">点击领取</a>
    `, To: options.To }, options));
}
exports.notifyEmail = notifyEmail;
function notify(type, options) {
    const handler = NotifyHandler[type];
    assert.ok(handler, `unknown type: ${type}`);
    return handler(options)
        .then(res => res.json())
        .catch(console.error)
        .then(console.log);
}
exports.default = notify;
//# sourceMappingURL=notify.js.map